// -- == //
import NewsTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import PrimaryButton from 'components/form/buttons/primaryButton';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function NewsPage() {
  const { news } = useTypedSelector((state: any) => state.News);

  return (
    <S.Container>
      <PageTitle title="News" />
      <S.Head>
        <PrimaryButton link="/panel/news/create">
          <PlusIcon />
          New article
        </PrimaryButton>
      </S.Head>
      <NewsTable data={news.data} loading={news.loading} />
    </S.Container>
  );
}
